(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscription", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/subscriptionView.html",
            controller: ["$state", SubscriptionCtrl],
            controllerAs: "vm"
        };
        function SubscriptionCtrl($state) {
            if ($state.current.name === "main.settings.subscription") {
                $state.go("main.settings.subscription.currentSubscription");
            }
        }
    });
}());
